var nav = {
  airports: {
    header: 'Airport Extras',
    classCheck: 'airportProducts',
    columns: [
      {
        parking: {
          text: 'Airport Parking',
          strong: true,
          canSell: 'CarParkBookings',
          links: [
            {
              divider: true
            }, {
              link: '/airport-parking.html',
              text: 'Airport Parking'
            }, {
              link: '/gatwick-airport-parking.html',
              text: 'Gatwick Airport Parking'
            }, {
              link: '/manchester-airport-parking.html',
              text: 'Manchester Airport Parking'
            }, {
              link: '/luton-airport-parking.html',
              text: 'Luton Airport Parking'
            }, {
              link: '/stansted-airport-parking.html',
              text: 'Stansted Airport Parking'
            }, {
              link: '/heathrow-airport-parking.html',
              text: 'Heathrow Airport Parking'
            }, {
              link: '/birmingham-airport-parking.html',
              text: 'Birmingham Airport Parking'
            }, {
              link: '/eastmidlands-airport-parking.html',
              text: 'East-Midlands Airport Parking'
            }, {
              link: '/bristol-airport-parking.html',
              text: 'Bristol Airport Parking'
            }, {
              link: '/liverpool-airport-parking.html',
              text: 'Liverpool Airport Parking'
            }, {
              link: '/belfast-airport-parking.html',
              text: 'Belfast Airport Parking'
            }, {
              link: '/leeds-bradford-airport-parking.html',
              text: 'Leeds Bradford Airport Parking'
            }, {
              link: '/edinburgh-airport-parking.html',
              text: 'Edinburgh Airport Parking'
            }, {
              link: '/glasgow-airport-parking.html',
              text: 'Glasgow Airport Parking'
            }, {
              link: '/newcastle-airport-parking.html',
              text: 'Newcastle Airport Parking'
            }, {
              link: '/cardiff-airport-parking.html',
              text: 'Cardiff Airport Parking'
            }, {
              link: '/airport-parking.html',
              text: 'Other UK Airports'
            }
          ]
        }
      }, {
        hotels: {
          text: 'Airport Hotels',
          strong: true,
          canSell: 'HotelBookings',
          links: [
            {
              divider: true
            }, {
              link: '/airport-hotels.html',
              text: 'Airport Hotels'
            }, {
              link: '/gatwick-airport-hotels.html',
              text: 'Gatwick Airport Hotels'
            }, {
              link: '/manchester-airport-hotels.html',
              text: 'Manchester Airport Hotels'
            }, {
              link: '/luton-airport-hotels.html',
              text: 'Luton Airport Hotels'
            }, {
              link: '/stansted-airport-hotels.html',
              text: 'Stansted Airport Hotels'
            }, {
              link: '/heathrow-airport-hotels.html',
              text: 'Heathrow Airport Hotels'
            }, {
              link: '/birmingham-airport-hotels.html',
              text: 'Birmingham Airport Hotels'
            }, {
              link: '/eastmidlands-airport-hotels.html',
              text: 'East-Midlands Airport Hotels'
            }, {
              link: '/bristol-airport-hotels.html',
              text: 'Bristol Airport Hotels'
            }, {
              link: '/liverpool-airport-hotels.html',
              text: 'Liverpool Airport Hotels'
            }, {
              link: '/belfast-airport-hotels.html',
              text: 'Belfast Airport Hotels'
            }, {
              link: '/leeds-bradford-airport-hotels.html',
              text: 'Leeds Bradford Airport Hotels'
            }, {
              link: '/edinburgh-airport-hotels.html',
              text: 'Edinburgh Airport Hotels'
            }, {
              link: '/glasgow-airport-hotels.html',
              text: 'Glasgow Airport Hotels'
            }, {
              link: '/newcastle-airport-hotels.html',
              text: 'Newcastle Airport Hotels'
            }, {
              link: '/cardiff-airport-hotels.html',
              text: 'Cardiff Airport Hotels'
            }, {
              link: '/airport-hotels.html',
              text: 'Other UK Airports'
            }
          ]
        }
      }, {
        lounges: {
          text: 'Airport Lounges',
          strong: true,
          canSell: 'LoungeBookings',
          links: [
            {
              divider: true
            }, {
              link: '/airport-lounges.html',
              text: 'Airport Lounges'
            }, {
              link: '/gatwick-airport-lounges.html',
              text: 'Gatwick Airport Lounges'
            }, {
              link: '/manchester-airport-lounges.html',
              text: 'Manchester Airport Lounges'
            }, {
              link: '/luton-airport-lounges.html',
              text: 'Luton Airport Lounges'
            }, {
              link: '/stansted-airport-lounges.html',
              text: 'Stansted Airport Lounges'
            }, {
              link: '/heathrow-airport-lounges.html',
              text: 'Heathrow Airport Lounges'
            }, {
              link: '/birmingham-airport-lounges.html',
              text: 'Birmingham Airport Lounges'
            }, {
              link: '/eastmidlands-airport-lounges.html',
              text: 'East-Midlands Airport Lounges'
            }, {
              link: '/bristol-airport-lounges.html',
              text: 'Bristol Airport Lounges'
            }, {
              link: '/liverpool-airport-lounges.html',
              text: 'Liverpool Airport Lounges'
            }, {
              link: '/belfast-airport-lounges.html',
              text: 'Belfast Airport Lounges'
            }, {
              link: '/leeds-bradford-airport-lounges.html',
              text: 'Leeds Bradford Airport Lounges'
            }, {
              link: '/edinburgh-airport-lounges.html',
              text: 'Edinburgh Airport Lounges'
            }, {
              link: '/glasgow-airport-lounges.html',
              text: 'Glasgow Airport Lounges'
            }, {
              link: '/newcastle-airport-lounges.html',
              text: 'Newcastle Airport Lounges'
            }, {
              link: '/cardiff-airport-lounges.html',
              text: 'Cardiff Airport Lounges'
            }, {
              link: '/airport-lounges.html',
              text: 'Other UK Airports'
            }, {
              link: '/european-airport-lounges.html',
              text: 'European Airport Lounges'
            }, {
              link: '/worldwide-airport-lounges.html',
              text: 'Worldwide Airport Lounges'
            }, {
              link: '/group-bookings.html',
              text: 'Group Bookings'
            }
          ]
        }
      }, {
        transfers: {
          text: 'Airport Transfers',
          strong: true,
          canSell: 'TransferBookings',
          links: [
            {
              divider: true
            }, {
              link: '/airport-transfers.html',
              text: 'Airport Transfers'
            }, {
              link: '/tenerife-airport-transfers.html',
              text: 'Tenerife Airport Transfers'
            }, {
              link: '/majorca-airport-transfers.html',
              text: 'Majorca Airport Transfers'
            }, {
              link: '/alicante-airport-transfers.html',
              text: 'Alicante Airport Transfers'
            }, {
              link: '/lanzarote-airport-transfers.html',
              text: 'Lanzarote Airport Transfers'
            }, {
              link: '/faro-airport-transfers.html',
              text: 'Faro Airport Transfers'
            }, {
              link: '/gran-canaria-airport-transfers.html',
              text: 'Gran Canaria Airport Transfers'
            }, {
              link: '/malaga-airport-transfers.html',
              text: 'Malaga Airport Transfers'
            }, {
              link: '/fuerteventura-airport-transfers.html',
              text: 'Fuerteventura Airport Transfers'
            }, {
              link: '/malta-airport-transfers.html',
              text: 'Malta Airport Transfers'
            }, {
              link: '/dalaman-airport-transfers.html',
              text: 'Dalaman Airport Transfers'
            }, {
              link: '/barcelona-airport-transfers.html',
              text: 'Barcelona Airport Transfers'
            }, {
              link: '/paris-airport-transfers.html',
              text: 'Paris Airport Transfers'
            }, {
              link: '/antalya-airport-transfers.html',
              text: 'Antalya Airport Transfers'
            }, {
              link: '/orlando-airport-transfers.html',
              text: 'Orlando Airport Transfers'
            }, {
              link: '/krakow-airport-transfers.html',
              text: 'Krakow Airport Transfers'
            }, {
              link: '/paphos-airport-transfers.html',
              text: 'Paphos Airport Transfers'
            }
          ]
        }
      }
    ]
  },
  otherProducts: {
    header: 'Other Extras',
    classCheck: 'otherProducts',
    columns: [
      {
        insurance: {
          text: 'Travel Insurance',
          strong: true,
          canSell: 'InsuranceBookings',
          links: [
            {
              divider: true
            }, {
              link: '/travel-insurance.html',
              text: 'Travel Insurance'
            }, {
              link: '/travel-insurance/single-trip.html',
              text: 'Single Trip Travel Insurance'
            }, {
              link: '/travel-insurance/annual-multi-trip.html',
              text: 'Annual Travel Insurance'
            }, {
              link: '/travel-insurance/medical-conditions.html',
              text: 'Pre-existing Medical Conditions'
            }, {
              link: '/travel-insurance/over-65s.html',
              text: 'Over 65s Travel Insurance'
            }, {
              link: '/travel-insurance/family.html',
              text: 'Family Travel Insurance'
            }, {
              link: '/travel-insurance/children.html',
              text: 'Children\'s Travel Insurance'
            }
          ]
        },
        Extras: {
          text: 'Extras',
          strong: true,
          canSell: 'AttractionTicket',
          links: [
            {
              divider: true
            }, {
              link: 'https://www.onlineticketstore.co.uk/?affiliate_Id=holidayextras&amp;launch_id=HD',
              text: 'Attraction Tickets',
              canSell: 'AttractionTicket'
            }, {
              link: '/fast-track.html',
              text: 'Fast Track',
              canSell: 'FastTrack'
            }
          ]
        }
      }, {
        carhire: {
          text: 'Holiday Car Hire',
          strong: true,
          canSell: 'CarHireBookings',
          links: [
            {
              divider: true
            }, {
              link: '/car-hire.html?launch_id=HD',
              text: 'Car Hire'
            }, {
              link: '/car-hire/spain.html',
              text: 'Car Hire Spain'
            }, {
              link: '/car-hire/uk.html',
              text: 'Car Hire UK'
            }, {
              link: '/car-hire/greece.html',
              text: 'Car Hire Greece'
            }, {
              link: '/car-hire/italy.html',
              text: 'Car Hire Italy'
            }, {
              link: '/car-hire/portugal.html',
              text: 'Car Hire Portugal'
            }, {
              link: '/car-hire/france.html',
              text: 'Car Hire France'
            }, {
              link: '/car-hire/usa.html',
              text: 'Car Hire USA'
            }, {
              link: '/car-hire/cyprus.html',
              text: 'Car Hire Cyprus'
            }
          ]
        },
        sunscreen: {
          text: 'Sunscreen',
          strong: true,
          links: [
            {
              divider: true
            }, {
              link: '/altruist-sunscreen.html',
              text: 'Altruist Sunscreen'
            }
          ]
        }
      }, {
        money: {
          text: 'Travel Money',
          strong: true,
          links: [
            {
              divider: true
            }, {
              link: '/travel-money-cash.html',
              text: 'Travel Money Cash'
            }
          ]
        },
        theatre: {
          text: 'Theatre Breaks',
          canSell: 'TheatreBreaks',
          strong: true,
          links: [
            {
              divider: true
            }, {
              link: '/theatre-breaks.html',
              text: 'Theatre Breaks'
            }, {
              link: '/theatre-breaks/wicked-the-musical.html',
              text: 'Wicked the Musical'
            }
          ]
        },
        other: {
          text: 'Holiday Travel',
          strong: true,
          excludeAgent: ['WL329', 'WL370'],
          excludeGroup: ['B6'],
          links: [
            {
              divider: true
            }, {
              link: '/airport-taxi.html?launch_id=HD',
              text: 'Airport Taxi'
            }, {
              link: '/airports-by-rail.html',
              text: 'Airports by Rail',
              canSell: 'RailBookings'
            }, {
              link: '/airport-hotels/with-coach.html',
              text: 'Hotels with Coach',
              canSell: 'HotelBookings'
            }
          ]
        }
      }, {
        parking: {
          text: 'Port Parking',
          strong: true,
          canSell: 'CarParkBookings',
          links: [
            {
              divider: true
            }, {
              link: '/port-parking.html',
              text: 'Port Parking'
            }, {
              link: '/dover-port-parking.html',
              text: 'Dover Port Parking'
            }, {
              link: '/southampton-port-parking.html',
              text: 'Southampton Port Parking'
            }
          ]
        },
        hotels: {
          text: 'Port Hotels',
          strong: true,
          canSell: 'HotelBookings',
          links: [
            {
              divider: true
            }, {
              link: '/port-hotels.html',
              text: 'Port Hotels'
            }, {
              link: '/dover-port-hotels.html',
              text: 'Dover Port Hotels'
            }, {
              link: '/southampton-port-hotels.html',
              text: 'Southampton Port Hotels'
            }
          ]
        },
        cruise: {
          text: 'Cruise',
          strong: true,
          links: [
            {
              divider: true
            }, {
              link: 'https://www.cruisingexcursions.com/affiliate/holiday-extras',
              text: 'Cruise Excursions'
            }
          ]
        }
      }
    ]
  },
  helpAndSupport: {
    header: 'Help and Support',
    pageMatch: 'help-and-support',
    mainLink: '/help-and-support.html'
  },
  search: {
    placeHolder: 'Search',
    action: '/search.html',
    link: 'https://www.holidayextras.co.uk/search.html'
  }
}

module.exports = nav
